(function () {
  var config = window.__PDP_VISIT_REWARD_COUNTDOWN__;
  if (!config || !config.productId) return;
  const params = new URLSearchParams(window.location.search);
  const taskId = params.get('taskId');
  const taskSource = params.get('taskSource');
  const globalConfig = window.__MC__CONFIG__ || {};
  const token = getCookie(globalConfig.cookieName || 'momcozy-token');
  if (!token || !taskId || taskSource !== 'page_26BrandDay') return;
  const durationSeconds = Number(config.duration || 10);
  const eventType = Number(config.eventType || 91);
  const reportSource = taskSource || 'page_26BrandDay';
  let countdownToastId = '';
  let timerId = null;
  let endAt = 0;

  function getCookie(name) {
    var cookiePrefix = encodeURIComponent(name) + '=';
    var cookies = document.cookie ? document.cookie.split(';') : [];
    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(cookiePrefix) === 0) {
        return decodeURIComponent(cookie.slice(cookiePrefix.length));
      }
    }
    return '';
  }

  waitForProductReady().then(function (isProductReady) {
    if (!isProductReady) return false;

    return shouldShowCountdown();
  }).then(function (shouldShow) {
    if (!shouldShow) return false;

    return waitForDsmToast();
  }).then(function (isToastReady) {
    if (!isToastReady) return;

    endAt = Date.now() + durationSeconds * 1000;

    var remaining = getRemainingSeconds();
    if (remaining <= 0) {
      reportTask();
      return;
    }

    startCountdown(remaining);
  });

  function getRemainingSeconds() {
    return Math.max(0, Math.ceil((endAt - Date.now()) / 1000));
  }

  function waitForProductReady() {
    return new Promise(function (resolve) {
      var selector = config.productRootSelector || '.t4s-main-product__content';

      function isReady() {
        return document.readyState !== 'loading' && document.querySelector(selector);
      }

      if (isReady()) {
        resolve(true);
        return;
      }

      var attempts = 0;
      var readyTimer = window.setInterval(function () {
        attempts += 1;
        if (isReady()) {
          window.clearInterval(readyTimer);
          resolve(true);
        } else if (attempts >= 50) {
          window.clearInterval(readyTimer);
          resolve(false);
        }
      }, 100);
    });
  }

  function waitForDsmToast() {
    return new Promise(function (resolve) {
      if (window.DsmToast) {
        resolve(true);
        return;
      }

      var attempts = 0;
      var waitTimer = window.setInterval(function () {
        attempts += 1;
        if (window.DsmToast) {
          window.clearInterval(waitTimer);
          resolve(true);
        } else if (attempts >= 30) {
          window.clearInterval(waitTimer);
          resolve(false);
        }
      }, 100);
    });
  }

  function startCountdown(initialSeconds) {
    countdownToastId = showCountdownToast(initialSeconds);

    timerId = window.setInterval(function () {
      var remaining = getRemainingSeconds();
      if (remaining <= 0) {
        window.clearInterval(timerId);
        closeCountdownToast();
        reportTask();
        return;
      }

      updateCountdownToast(remaining);
    }, 1000);
  }

  function showCountdownToast(seconds) {
    if (!window.DsmToast) return '';
    return window.DsmToast.show({
      message: getCountdownMessage(seconds),
      tone: 'default',
      duration: 0,
      showClose: false,
      placement: 'top-center',
    });
  }

  function updateCountdownToast(seconds) {
    if (!countdownToastId) return;
    var toast = document.getElementById('dsm-toast-' + countdownToastId);
    var message = toast && toast.querySelector('.dsm-toast__message');
    if (message) message.textContent = getCountdownMessage(seconds);
  }

  function closeCountdownToast() {
    if (countdownToastId && window.DsmToast) {
      window.DsmToast.dismiss(countdownToastId);
    }
    countdownToastId = '';
  }

  function getCountdownMessage(seconds) {
    var message = config.countdownMessage || 'Stay on this page for 10s to claim your reward.';
    return message.replace('[seconds]', seconds);
  }

  function getApiBase() {
    return (window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl) || 'https://account.momcozy.com';
  }

  function getHeaders() {
    var headers = { 'Content-Type': 'application/json' };
    if (window.__MC__CONFIG__ && window.__MC__CONFIG__.headers) {
      Object.assign(headers, window.__MC__CONFIG__.headers);
    }
    headers.Authorization = 'Bearer ' + token;
    return headers;
  }

  async function shouldShowCountdown() {
    try {
      var response = await fetch(getApiBase() + '/api/station/activity/brandday-2026/point/task/browse-progress', {
        method: 'GET',
        headers: getHeaders(),
      });
      if (!response.ok) return false;

      var data = await response.json();
      var progress = data && data.result;
      if (!progress) return false;
      if (progress.dailyLimitReached) return false;

      var browsedProductIds = Array.isArray(progress.allBrowsedProductIds)
        ? progress.allBrowsedProductIds
        : [];
      return browsedProductIds.map(String).indexOf(String(config.productId)) === -1;
    } catch (error) {
      return false;
    }
  }

  function showSuccessToast() {
    if (!window.DsmToast) return;
    window.DsmToast.show({
      message: config.successMessage || 'Reward claimed successfully',
      tone: 'success',
      placement: 'top-center',
    });
  }

  async function reportTask() {
    try {
      var response = await fetch(getApiBase() + '/api/station/activity/brandday-2026/point/task/report', {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
          productId: config.productId,
          eventType: eventType,
          source: reportSource,
        }),
      });

      if (!response.ok) throw new Error('Task report failed');

      var data = await response.json().catch(function () { return null; });
      if (data && data.code !== '200') return;
      if(data?.result?.alreadyCompleted) return;
      showSuccessToast();
    } catch (error) {}
  }
})();